// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1YRcR","footer":"ModalFilter_footer__445bR"};